<template>
    <div class="employee-tab-inner">
        <!--<ul class="list-group mb-3 " v-if='errormsg'>
            <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
        </ul>-->
        <b-overlay :show="showoverlay" rounded="sm">
            <div class="pf-reporting-tab payroll-reporting-tab" id="nav-tabContent-intro2" v-if="$acl['pf-employee-registration'] > 0">

                 <b-tabs content-class="mt-3 reports-tab-wrapper" nav-wrapper-class="mt-4 reports-tab-nav">
                     <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                    <!-- Mustafijur Removed 50px from img -->
                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" /><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" />
                                    <h5>Registered Employees</h5>
                                    <p>Employees those have been registered to PF.</p>
                                    <b-button class="btn btn-primary">View</b-button> <!-- Mustafijur: 23-05-2026: View Report to View-->
                                </div>

                            </template>
                            <div class="">
                               <div v-if="em_reg_custom_list.length>0">

                                   <div class="card-header px-0 bg-transparent border-0">
                                        <div class="row no-margin">
                                            <div class="col-sm-6 pl-0" >
                                                <div class="employee-btn-holder" style="max-width:260px" v-if="$acl['pf-employee-registration'] > 1">
                                                    <div class="report-intro" style="text-align:left">
                                                        Bulk Update
                                                    </div>
                                                    <div  style="min-height:5px;">
                                                    </div>
                                                    <b-button @click="exportUpdatePFSelected" ><b-icon icon="code-slash" ></b-icon> Template</b-button>
                                                    <b-button :href="$api_url+'/pf/employee/import/update'"><b-icon icon="box-arrow-up" class="" scale="1"></b-icon> Import</b-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                <common-list  :pageurl="this.$api_url" :is_action="1" :is_pf="is_n_pf" :checkbox="checkbox"  :appended_column="em_reg_appended_column" :key="em_reg_list_key" :company_options="em_reg_company_options" :employees="em_reg_custom_list" :default_column="em_reg_default_column" :primary_key="em_reg_primary_key" v-on:childToParent="reg_edit"></common-list>
                                </div>
                                <div v-else>

                                    <div v-if="show_loader" class="list-no-data">
                                        <span class="d-block text-center">Looking for relevant data..</span>
                                        <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                                    </div>
                                    <div v-else class="list-no-data">
                                        Looks like there is no PF registrations to show.
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab v-if="hide">
                            <template #title>
                                <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>View Application(s)
                                </div>
                                <div class="report-intro">
                                    All the PF applications and their status.
                                </div>
                                <b-button class="mt-3">View</b-button>
                            </template>
                            <div class="">
                                <div v-if="custom_list.length>0">
                                     <common-list  :pageurl="this.$api_url"  :is_action="is_action" :is_pf="is_n_pf" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
                                </div>
                                <div v-else>

                                    <div v-if="show_loader_2" class="list-no-data">
                                        <img v-if="show_loader_2" v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                                    </div>
                                    <div v-else class="list-no-data">
                                        Looks like there is no PF application to show.
                                    </div>

                                </div>
                               </div>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                    <!-- Mustafijur Removed 50px from img -->
                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" /><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon"/>
                                    <h5>Register Employee</h5>
                                    <p>Register choosen employee to PF.</p>
                                    <b-button class="btn btn-primary">View</b-button> <!-- Mustafijur: 23-05-2026: View Report to View-->
                                </div>
                                <!-- <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>Register Employee
                                </div>
                                <div class="report-intro">
                                    Register choosen employee to PF.
                                </div>
                                <b-button class="mt-3">View</b-button> -->
                            </template>
                            <div class="">



                                 <div v-if="reg_custom_list.length>0">

                                    <div class="card-header px-0 bg-transparent border-0">
                                    <div class="row no-margin">
                                    <div class="col-sm-6 pl-0" >
                                    <div class="employee-btn-holder" style="max-width:260px" v-if="$acl['pf-employee-registration'] > 1"> <!-- Mustafijur: 23-05-2026: width 260px from 210px-->
                                        <div class="report-intro" style="text-align:left"> <!-- Mustafijur: 23-05-2026: align-left-->
                                            Bulk Import
                                        </div>
                                        <div  style="min-height:5px;">
                                        </div>

                                        <b-button @click="exportPFSelected" ><b-icon icon="code-slash" ></b-icon> Template</b-button>
                                        <b-button :href="$api_url+'/pf/employee/import/add'"><b-icon icon="box-arrow-up" class="" scale="1"></b-icon> Import</b-button>

                                    </div>
                                    </div>
                                    </div>
                                    </div>




                                    <common-list  :pageurl="this.$api_url"  :checkbox="checkbox" :is_action="reg_is_action" :is_pf="is_n_pf" :appended_column="reg_appended_column" :key="reg_list_key" :company_options="reg_company_options" :employees="reg_custom_list" :default_column="reg_default_column" :primary_key="reg_primary_key" v-on:childToParent="reg_listReturn"></common-list>
                                </div>
                                <div v-else>

                                    <div v-if="show_loader_3" class="list-no-data">
                                        <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                                    </div>
                                    <div v-else class="list-no-data">
                                        Looks like there is no employee to show.
                                    </div>

                                </div>
                            </div>
                        </b-tab>
                    </b-tabs>
            </div>

            <b-modal size="md" id="bv-modal-process-application" hide-footer :title="'Approve PF application for '+curr_emp_name">
                <div class="d-block">
                    <b-form @submit.stop.prevent="approveSubmit">
                        <div class="clearfix">
                            <div class="row clearfix">
                            <div class="col-md-12 float-left">
                                <b-form-group id="pf_approve_date-group" label="PF Start Date [YYYY-MM-DD]" class="required-field" label-for="pf_approve_date">
                                    <b-input-group class="mb-3">
                                        <b-form-input id="pf_approve_date" name="pf_approve_date" v-model="pf_approve_date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{ required: true }"  aria-describedby="pf_approve_date-feedback" data-vv-as="PF Start Date"></b-form-input>
                                            <b-input-group-append>
                                                <b-form-datepicker id="pf_approve_date_picker" button-only right locale="en-US" v-model="pf_approve_date"  ></b-form-datepicker>
                                            </b-input-group-append>
                                        <!-- <b-form-invalid-feedback id="settlement_date-feedback">{{ veeErrors.first('settlement_date') }}</b-form-invalid-feedback> -->
                                    </b-input-group>
                                </b-form-group>
                            </div>
                          </div>
                        </div>

                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix" style="margin-right: 0;">
                            <b-button class="border rounded bg-light float-right py-1 px-5 mt-4 ml-2" type="submit" variant="primary">Submit</b-button>
                        </div>
                    </b-form>
                </div>
            </b-modal>


            <b-modal size="md" id="bv-modal-register-pf" hide-footer :title="'Register PF for '+curr_emp_name">
                <div class="d-block">
                    <b-form @submit.stop.prevent="addEmployeeToPf">
                        <div class="clearfix">
                            <div class="row clearfix">
                            <div class="col-md-12 float-left">
                                <b-form-group id="pf_approve_date-group" label="PF Start Date [YYYY-MM-DD]" class="required-field" label-for="pf_approve_date">

                                    <b-input-group class="mb-3">
                                        <b-form-input id="pf_approve_date" name="pf_approve_date" v-model="pf_approve_date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{ required: true }"  aria-describedby="pf_approve_date-feedback" data-vv-as="PF Start Date"></b-form-input>
                                            <b-input-group-append>
                                                <b-form-datepicker id="pf_approve_date_picker" button-only right locale="en-US" v-model="pf_approve_date" :min="min_date"  ></b-form-datepicker>
                                            </b-input-group-append>
                                        <!-- <b-form-invalid-feedback id="settlement_date-feedback">{{ veeErrors.first('settlement_date') }}</b-form-invalid-feedback> -->
                                    </b-input-group>
                                </b-form-group>
                            </div>
                          </div>
                        </div>

                        <div class="mt-1 mb-4 text-center">
                            <b-button class="mt-4" type="submit" variant="primary">Submit</b-button>
                        </div>
                    </b-form>
                </div>
            </b-modal>



            <b-modal size="md" id="bv-modal-update-pf" hide-footer :title="'Update PF for '+curr_update_employee">
                <div class="d-block">
                    <b-form @submit.stop.prevent="updateEmployeePF">
                        <div class="clearfix">
                            <div class="row clearfix">
                            <div class="col-md-12 float-left">
                                <b-form-group id="pf_approve_date-group" label="PF Start Date [YYYY-MM-DD]" class="required-field" label-for="curr_approve_date">
                                    <b-input-group class="mb-3">
                                        <b-form-input id="pf_approve_date" name="curr_approve_date" v-model="curr_approve_date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{ required: true }"  aria-describedby="curr_approve_date-feedback" data-vv-as="PF Start Date"></b-form-input>
                                            <b-input-group-append>
                                                <b-form-datepicker id="pf_approve_date_picker" button-only right locale="en-US" v-model="curr_approve_date" :min="min_date" ></b-form-datepicker>
                                            </b-input-group-append>
                                        <!-- <b-form-invalid-feedback id="settlement_date-feedback">{{ veeErrors.first('settlement_date') }}</b-form-invalid-feedback> -->
                                    </b-input-group>
                                </b-form-group>
                            </div>
                          </div>
                        </div>

                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 0;"> <!-- Mustafijur: 16-07-2026: added text-center -->
                            <b-button class="border rounded bg-light py-1 px-5 mt-4" type="submit" variant="primary">Submit</b-button> <!-- Mustafijur: 16-07-2026: removed float-right, ml-2 -->
                        </div>
                    </b-form>
                </div>
            </b-modal>

            <b-modal id="delete-modal" title="Are you sure you want to delete this PF Registration?" hide-footer>
                <br />
                <div style="height: 10px;clear:both;"> &nbsp;</div>
                <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deletePF(curr_update_id)">Delete </a>
                &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal')">Cancel</a>
                <div style="height: 5px;clear:both;"> &nbsp;</div>
            </b-modal>





        </b-overlay>
        <b-modal  id="bv-modal-pf-details" hide-footer  title="Employee Profile" size="lg">
            <b-overlay rounded="sm">

                <div>
                    <div class="clearfix pl-0 col-md-12">
                        <div class="row justify-content-center modal-title">
                            <h5 class="modal-title text-center">{{ report_data.company_name }}</h5>
                        </div>
                        <div class="row justify-content-center pb-4">
                            Employees Provident Fund Scheme - {{ employee_info.employee_name }}
                        </div>
                        <div class='text-right mb-3' @click="getEmployeePfReport(employee_info.employee_id)"><a href="#" class="px-3 py-1 border rounded" style="border:1px solid green !important; color: green;" ><i class="far fa-file-excel mr-1"></i> Download Schedule</a></div>
                        <!-- Mustafijur  -->
                        <div class="row col-12 no-margin px-0">
                            <div class="col-md-12">
                                <div class="ibox-content pf-overview px-0 pb-0">
                                    <div class="payslip-details-info-inner row">
                                        <template >
                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Employee ID</div>
                                                    <div class="second"> {{ employee_info.employee_code }} </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Employee Name</div>
                                                    <div class="second"> {{ employee_info.employee_name }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Job Position</div>
                                                    <div class="second"> {{ employee_info.jobposition }} </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Joining Date</div>
                                                    <div class="second"> {{ employee_info.joining_date }} </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">PF Enrollment Date</div>
                                                    <div class="second">{{ employee_info.PF_enrollment_date }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">Opening Balance of Fund</div>
                                                    
                                                    <div class="second">{{ formatMoney(details.opening_balance) }}</div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Service Period</div>
                                                    <div class="second">{{ employee_info.service_period }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">PF Membership Period</div>
                                                    
                                                    <div class="second">{{ employee_info.PF_membership_period }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">Closing Balance of Fund</div>
                                                    
                                                    <div class="second">{{ formatMoney(employee_info.closing_balance_of_fund) }}</div>
                                                </div>
                                            </div>
                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">PF Deregistration Date</div>
                                                    
                                                    <div class="second">{{ employee_info.pf_leave_date }}</div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <!-- Mustafijur  -->
                    </div>
                </div>
                <!-- <div v-if="details.length == 0" class="px-3 py-3 no-result-cell text-center">

                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div  v-else>
                <div class="clearfix border rounded mt-3  py-2 mb-2 mr-3 mb-0 col-md-12">
                        <div class="row justify-content-center">
                            {{report_data.company_name}}
                        </div>
                        <div class="row justify-content-center">
                            {{report_data.title}}
                        </div>
                    </div>
                    <div class="clearfix border rounded mt-3 mb-2 mr-3 py-2 mb-0 col-md-12">
                        <div class="row justify-content-center mb-2">
                            Employee Information
                        </div>
                        <table class="table">
                            <tr>
                                <td class="2">
                                    Employee ID
                                </td>
                                <template v-if="employee_info.employee_code!=''">
                                    <td class="2 text-left">
                                        {{employee_info.employee_code}}
                                    </td>
                                </template>
                                <template v-else>
                                    <td class="2 text-left">
                                        N/A
                                    </td>
                                </template>
                                <td class="2">
                                    PF Membership Period
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.PF_membership_period}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    Employee Name
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.employee_name}}
                                </td>
                                <td class="2">
                                    Service Period
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.service_period}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    Job Position
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.jobposition}}
                                </td>
                                <td class="2">
                                    Opening Balance Of Fund
                                </td>
                                <td class="2 text-left">
                                    {{formatMoney(details.opening_balance)}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    Joining Date
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.joining_date}}
                                </td>
                                <td class="2">
                                    Closing Balance Of Fund
                                </td>
                                <td class="2 text-left">
                                    {{formatMoney(employee_info.closing_balance_of_fund)}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    PF Enrollment Date
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.PF_enrollment_date}}
                                </td>
                            </tr>
                            <template v-if="employee_info.PF_leave_date!='0000-00-00'">
                                <tr>
                                    <td class="2">
                                        PF Leave Date
                                    </td>
                                    <td class="2 text-left">
                                        {{employee_info.PF_leave_date}}
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </div>

                </div> -->


            </b-overlay>
        </b-modal>
    </div>
</template>

<script>

    export default{
        mounted() {
            //if(this.employeedata.last_working_day == '0000-00-00')
                //this.fdata.last_working_day = '';

            this.showoverlay = false;
        },
        props: ['pageurl' , 'flg'],
        components: {
        },
        data(){
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today);
            return {

                cu:window.location.href,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : true,

                pf_start_date : '',
                errormsg:[],
				hide:false,
                checkbox:1,

                show_loader:true,
                show_loader_2:true,
                show_loader_3:true,


                pf_del_id : 0,
                pgurl:this.$api_url,
                /* start pf signup variables */
                per_page:20,
                application_lists: [],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                application_loading : false,
                employeesearch:{name:'',status:1},
                users : [],
                em_tmp_custom_list:[],
                eligible_pf: 0,
                chosen_emp_id: 0,
                curr_emp_name: '',
                curr_emp_id: 0,
                curr_app_id: 0,
                last_payslip_date:'',
                pf_approve_date: '',
                min_date:minDate,
                pfoverlay : true,
                report_data : [],
                details : [],
                employee_info : [],



                /**Child Component property data */


                is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                custom_list:[],  /* Data List */
                default_column:['name'], /* Default Column List */
                appended_column:[
                    { value: "reg_applied_date", text: "Application Date",type: "text"},
                    { value: "status", text: "Status",type: "text"},

                ],                   /* Appended Column List  and there title and type */
                primary_key:'id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                tmp_custom_list:[],

                custom_array:[],


                /***Child Component property data */





                /**Child Component property data */

                is_n_pf:1,
                reg_is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                reg_list_key:0, /* Component Key */
                reg_custom_list:[],  /* Data List */
                reg_default_column:['name','email','jobposition','branch'], /* Default Column List */
                reg_appended_column:[],                   /* Appended Column List  and there title and type */
                reg_primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                reg_company_options:[],         /* Company Filterable options */

                reg_tmp_custom_list:[],

                reg_custom_array:[],




                em_reg_appended_column:[
                    { value: "pf_start", text: "PF Start Date",type: "date"},
                    { value: "pf_end", text: "PF End Date",type: "date"},
                    // { value: "status", text: "Status",type: "text"}, // Rejwan: 23-06-2026

                ],
                em_reg_tmp_custom_list:[],
                em_reg_company_options:[],
                em_reg_custom_list:[],
                em_reg_list_key:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                em_reg_list_key:0,
                em_reg_primary_key:'id',
                em_reg_default_column:['name','email','jobposition','branch'], /* Default Column List */
                em_selected: [],
                selected: [],


                /***Child Component property data */


                curr_update_id:'',
                curr_approve_date:'',
                curr_update_employee:'',


            }
        },
        methods:{
            formatMe(d)
            {
                return moment(d).format('DD/MM/YYYY');
            },

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            /*start pf signup functions*/

        exportUpdatePFSelected: function()
        {
            if(this.em_selected == '')
            this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
            else
            {
                this.exportUpdatetPF('selected');
            }

        },

        exportUpdatetPF: function(sltd='')
        {

            this.$bvToast.toast('It might take a while', {
                                    title: `Info`,
                                    variant: 'info',
                                    solid: true
                                });
            console.log(this.em_selected);

            this.showoverlay = true;
            let formData = new FormData();
            if(sltd.length>0 && this.em_selected)
            formData.append('ids', this.em_selected);

            this.downloadBlobResponse(
                axios.post(this.$api_url + '/pf/employee/export/update', formData, { responseType: 'blob' }),
                'showoverlay' // your loader key in this component
            );

        },


        download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },


        exportPFSelected: function()
        {
            if(this.selected == '')
            this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
            else
            {
                this.exportPF('selected');
            }

        },

        exportPF: function(sltd='')
        {

            this.$bvToast.toast('It might take a while', {
                                    title: `Info`,
                                    variant: 'info',
                                    solid: true
                                });
            console.log(this.selected);

            this.showoverlay = true;
            let formData = new FormData();
            if(sltd.length>0 && this.selected)
            formData.append('employee_ids', this.selected);

            this.downloadBlobResponse(
                axios.post(this.$api_url + '/pf/employee/export/add', formData, { responseType: 'blob' }),
                'showoverlay' // your loader key in this component
            );

        },


          processApplication: function(emp_application,action)
		  {
		     //alert(emp_application.employee_id+'::'+emp_application.employee_name+'::'+emp_application.reg_applied_date);
             this.curr_emp_name = emp_application.name;
             this.curr_emp_id = emp_application.employee_id;
             this.curr_app_id = emp_application.id;

             if(action == 1)
             {
                axios.get(this.$api_url+'/pf/eligible', {
							  params: {
								  emp_id: this.curr_emp_id
							  }
		        }).then(function(response){
		            if (response.data.success)
                    {
                        this.getEmployeeLastPayslip(this.curr_emp_id);
                        this.$bvModal.show('bv-modal-process-application');
				    }
    				else if(response.data.errors)
    				{
                        this.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                        curr_obj.employeesearch.name = "";
                        curr_obj.users = [];
                    }
                    else
                    {
                        this.$bvToast.toast("Server error!!!", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                        curr_obj.employeesearch.name = "";
                        curr_obj.users = [];
                    }
		       }.bind(this));

             }
             if(action == 3)
             {
                this.updateApplicationStatus(emp_application.id,3);
             }
          },
          updateEmployeePF: function()
          {
              if(this.curr_update_id && this.curr_update_employee && this.curr_approve_date){

               var curr_obj = this;

                let formData = new FormData();
                formData.append('id', this.curr_update_id);
                formData.append('pf_start_date', this.curr_approve_date);


                axios.post(this.$api_url + '/pf/employee/update', formData)
                .then(function (response)
                {
                    if(response.data.success){
                        this.$bvToast.toast("Successfully updated", {title: 'Success',variant: 'success',solid: true});
                        this.curr_update_id =0;
                        this.curr_update_employee =0;
                        this.curr_approve_date =0;
                        // this.getapplications();
                        this.pfgetEmployees();
                        this.pfGetRegisteredEmployees();

                    }else if(response.data.errors){
                        this.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                    }
                    this.$bvModal.hide('bv-modal-update-pf');
                }.bind(this))
                .catch(function (error)
                {
                    currentObj.errormsg = error.response.data.errors;
                });
              }
              else{
		      this.$bvToast.toast("Please enter valid PF Start Date.", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
		    }
          },

          addEmployeeToPf: function()
		  {


          if(this.chosen_emp_id && this.pf_approve_date){
          var curr_obj = this;

          let formData = new FormData();
          formData.append('emp_id', this.chosen_emp_id);
          formData.append('pf_start_date', this.pf_approve_date);

		  axios.post(this.$api_url + '/pf/employee/add', formData)
            .then(function (response)
            {
                if(response.data.success){
                    this.$bvToast.toast("Successfully added", {title: 'Success',variant: 'success',solid: true});
                    curr_obj.employeesearch.name = "";
                    curr_obj.pf_start_date  = "";
                    this.pf_approve_date = '';
                    curr_obj.chosen_emp_id = 0;
                    curr_obj.users = [];
                    this.pfGetRegisteredEmployees();
                    this.pfgetEmployees();

                }else if(response.data.errors){
                    this.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                }
                this.$bvModal.hide('bv-modal-register-pf');
            }.bind(this))
            .catch(function (error)
            {
                currentObj.errormsg = error.response.data.errors;
            });

		    }else{
		      this.$bvToast.toast("Please enter valid PF Start Date.", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
		    }

           },

            getEmployeeLastPayslip(emp_id){
                let formData = new FormData();
                formData.append('employee_id',emp_id);
                axios.post(this.$api_url + '/pf/get-employee-last-payslip-date-post', formData)
                        .then(function (response)
                        {
                            this.last_payslip_date = response.data;
                            if(this.last_payslip_date.length>0)
                            {

                                const last_payslip_array = this.last_payslip_date.split('-');
                                const last = new Date(this.last_payslip_date);
                                const lasttoday = new Date(last_payslip_array[0],last_payslip_array[1]-1,last_payslip_array[2]);
                                console.log(lasttoday);
                                const now = new Date();
                                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

                                if(today > lasttoday)
                                {
                                    //this.min_date = new Date(now);
                                    const lasttoday2 = new Date(last_payslip_array[0],last_payslip_array[1],1);

                                    console.log(lasttoday2);
                                    this.min_date = new Date(lasttoday2);
                                }
                                else
                                {
                                    const lasttoday2 = new Date(last_payslip_array[0],last_payslip_array[1],1);

                                    console.log(lasttoday2);
                                    this.min_date = new Date(lasttoday2);

                                }

                            }
                            else
                            {
                                axios.post(this.$api_url + '/pf/get-active-contract-start-date', formData)
                                .then(function (response)
                                {
                                    //this.min_date =response.data;
                                    this.min_date = new Date(response.data) // Rejwan: 25-02-2025

                                }.bind(this));

                            }

               }.bind(this));
            },
            pfgetEmployees: function()
            {
                let currentObj = this;
                this.show_loader_3 = true;
                axios.get(this.$api_url+'/pf/employee/all' , {

                }).then(function(response){


                /* Assingning the list */
                this.reg_tmp_custom_list = response.data.employee_data;
                /* Assingning the Options */
                this.reg_company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));
                this.reg_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                //console.log(this.reg_custom_list.length);

                if(this.reg_custom_list.length > 0 )
                {
                    this.reg_custom_list.forEach(element => {

                            let dop = [];

                            if(this.$acl['pf-employee-registration'] > 1)
                            {
                                dop = dop.concat([{ label: 'Register' , value: 0 }]);
                            }

                            element.actions = dop;
                    });
                }

                // console.log('asdas');
                // console.log(this.reg_custom_list);

                //this.reg_custom_list = this.reg_tmp_custom_list;
                this.reg_list_key = this.list_key + 1;
                this.show_loader_3 = false;
            }.bind(this)).catch(function (error){
                console.log(error);
                currentObj.serverError(error);

                });
            },



            pfGetRegisteredEmployees: function()
            {
                let currentObj = this;
                currentObj.show_loader = true;
                axios.get(this.$api_url+'/pf/employee/reglist' , {

                }).then(function(response){


                this.em_reg_custom_list = [];
                this.em_tmp_custom_list = [];


                if (typeof response.data.employee_data !== 'undefined')
                {
                    /* Assingning the list */
                    this.em_reg_tmp_custom_list = response.data.employee_data;
                    /* Assingning the list */
                    this.em_tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));
                }
                if (typeof response.data.options !== 'undefined')
                {
                    /* Assingning the Options */
                    this.em_reg_company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));
                }



                /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */

                if(this.em_tmp_custom_list.length > 0 )
                {
                    this.em_tmp_custom_list.forEach(element => {
                            if(element.employee_id > 0)
                            {
                                element.pf_total = this.formatMoney(element.pf_total);
                                let dop = [];
                                let last_payslip =  element.last_payslip;


                                if(element.pf_end != '0000-00-00' && last_payslip != null)
                                {

                                    const last_payslip_array = last_payslip.split('-');
                                    var last_payslip_date = new Date(last_payslip_array[0],last_payslip_array[1],0);


                                    let pf_end =  element.pf_end;
                                    const pf_end_array = pf_end.split('-');
                                    var pf_end_date = new Date(pf_end_array[0],pf_end_array[1]-1,pf_end_array[2]);
                                    var pf_end_month = pf_end_date.getMonth() + 1;
                                    var pf_end_year = pf_end_date.getFullYear();

                                    // if (cur_month >= pf_end_month && cur_year == pf_end_year) {


                                    if(last_payslip_date.getTime() >= pf_end_date.getTime())
                                    {
                                            /*  If DropDown type one is First Choice */
                                        element.status = 'Unsettled';

                                    }


                                }
                                if(element.pf_end == '0000-00-00')
                                {
                                    element.pf_end ='';
                                }
                                if(element.locked == 1)
                                {
                                    if(this.$acl['pf-employee-registration'] > 1)
                                    {
                                        dop = dop.concat([{ label: 'Locked' , value: 0 }]);
                                    }

                                    dop = dop.concat([{ label: 'Quick View' , value: 3 }]);


                                }


                                /* If DropDown type one is Second Choice */
                                if(element.status == 'Active' && element.locked != 1)
                                {
                                    dop = dop.concat([{ label: 'Quick View' , value: 3 }]);

                                    if(this.$acl['pf-employee-registration'] > 1)
                                    {
                                        dop = dop.concat([{ label: 'Edit' , value: 1 }]);
                                        dop = dop.concat([{ label: 'Delete' , value: 2 }]);
                                    }


                                }
                                else
                                {
                                    dop = dop.concat([]);
                                }

                                /* Action for all column **/


                                element.actions = dop;

                            }
                        });


                this.em_reg_custom_list = this.em_tmp_custom_list;

                if(this.em_reg_custom_list.length > 0)
                {


                }
            }
            else
            {
                this.blankmsg = "No employee found as leaver";
            }


            this.em_reg_list_key = this.list_key + 1;
            currentObj.show_loader = false;

            }.bind(this)).catch(function (error){
                currentObj.show_loader = false;
                console.log(error);
                currentObj.serverError(error);

                });
            },
            pfDetailsNew: function(employee_id)
            {
                if(employee_id>0){
                let currentObj = this;

                let formData = new FormData();
                formData.append('employee_id', employee_id);
                formData.append('viewmode', 1);
                formData.append('d_type', 'excel');
                this.pfoverlay = true;
                this.report_data = [];
                this.details = [];
                this.employee_info = [];

                axios.post(this.$api_url + '/pf/report/profile', formData)
                                    .then(function (response)
                                    {
                                        this.report_data = response.data.file_name;
                                        this.employee_info = response.data.file_name.employee_info;
                                        this.details = response.data.file_name.data;
                                        this.pfoverlay = true;
                                    }.bind(this))
                                    .catch(function (error)
                                    {
                                        console.log(error);
                                    });

                    }

                    this.$bvModal.show('bv-modal-pf-details');

            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }

            //     return money;
            // },

           approveSubmit(e)
            {

                this.$validator.validateAll().then(result => {
                    if (!result) {

                        if(this.veeErrors.first('pf_approve_date'))
                        this.$bvToast.toast("Please enter valid PF start date", {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        });

                        return;
                    }

                e.preventDefault();
                let currentObj = this;
                const config = {

                }

                let formData = new FormData();
                formData.append('emp_id', this.curr_emp_id);
                formData.append('pf_start_date', this.pf_approve_date);

                axios.post(this.$api_url + '/pf/employee/add', formData)
                            .then(function (response)
                            {
                                if(response.data.success){
                                    this.$bvToast.toast("Successfully approved", {title: 'Success',variant: 'success',solid: true});
                                    this.updateApplicationStatus(this.curr_app_id,1);
                                    this.$bvModal.hide('bv-modal-process-application');
                                }else if(response.data.errors){
                                    this.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                                }
                                // this.getapplications();
                                this.pf_approve_date = '';
                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.errormsg = error.response.data.errors;
                            });
                    });

            },
           updateApplicationStatus(id,app_status)
            {
                let formData = new FormData();
                formData.append('id', id);
                formData.append('status', app_status);

                axios.post(this.$api_url + '/pf/application/update-status', formData)
                            .then(function (response)
                            {
                                if(response.data.success){
                                  this.$bvToast.toast("Successfully Updated", {title: 'Success',variant: 'success',solid: true});
                                //   this.getapplications();
                                }else if(response.data.errors){
                                  this.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                                }
                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.errormsg = error.response.data.errors;
                            });


            },
            reg_listReturn:function(data)
            {
                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                }
                else
                {
                    this.selected = [];

                }

                if(data.employee_id && data.action_id==0)
                {
                    this.pf_approve_date = '';
                    let asd = this.reg_custom_list;
                    this.chosen_emp_id = data.employee_id;



					this.getEmployeeLastPayslip(data.employee_id);
                    var item  = asd.find(item => item.employee_id === data.employee_id);
                    this.curr_emp_name = item.name;

                    this.$bvModal.show('bv-modal-register-pf');

                    //this.addEmployeeToPf(data.employee_id ,item)
                }



            },
            reg_edit:function(data)
            {
                console.log(data);

                this.curr_update_id = 0;
                this.curr_approve_date= 0;
                this.curr_update_employee= 0;

                if(data.selected.length > 0)
                {
                    this.em_selected = data.selected;
                }
                else
                {
                    this.em_selected = [];

                }



                if(data.id && data.action_id==1)
                {
                    var item  = this.em_reg_custom_list.find(item => item.id === data.id);

					this.getEmployeeLastPayslip(item.employee_id);
                    console.log(item);
                    this.curr_update_id =item.id;
                    this.curr_approve_date=item.pf_start;
                    this.curr_update_employee=item.name;
                    this.$bvModal.show('bv-modal-update-pf');

                    //this.processApplication(this.custom_array[data.id],data.action_id);
                }

                if(data.id && data.action_id==2)
                {
                    var item  = this.em_reg_custom_list.find(item => item.id === data.id);
					this.getEmployeeLastPayslip(item.employee_id);
                    this.curr_update_id =item.id;
                    this.curr_approve_date=item.pf_start;
                    this.curr_update_employee=item.name;
                    this.$bvModal.show('delete-modal');

                    //this.processApplication(this.custom_array[data.id],data.action_id);
                }

                if(data.id && data.action_id==3)
                {
                    var item  = this.em_reg_custom_list.find(item => item.id === data.id);
					this.pfDetailsNew(item.employee_id);
                    //this.processApplication(this.custom_array[data.id],data.action_id);
                }


            },

            deletePF:function(pf_id)
            {
                let formData = new FormData();
                formData.append('pf_id', pf_id);
                axios.post(this.$api_url+'/pf/employee/delete', formData)
                    .then(function (response)
                    {
                        this.$bvToast.toast("Successfully updated", {title: 'Success',variant: 'success',solid: true});
                        this.$bvModal.hide('delete-modal');
                        this.curr_update_id =0;
                        this.pfGetRegisteredEmployees();
                        this.pfgetEmployees();

                    }.bind(this))
                    .catch(function (error)
                    {
                        this.$bvToast.toast(error, {title: 'Error',variant: 'danger',solid: true});
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

            },

            listReturn:function(data)
            {
                if(data.id && data.action_id==1)
                {
                    this.processApplication(this.custom_array[data.id],data.action_id);
                }
                else if(data.id && data.action_id==3)
                {
                     this.processApplication(this.custom_array[data.id],data.action_id);
                }

            },
            getEmployeePfReport: function(employee_id)
            { 
                if(employee_id>0){
                    var curr_obj = this;
                    
                    let formData = new FormData();
                    formData.append('employee_id', employee_id); 
                    formData.append('d_type', 'excel'); 
                    this.loader = true;

                    this.downloadBlobResponse(
                        axios.post(this.$api_url + '/pf/report/profile', formData, { responseType: 'blob' }),
                        'loader' // your loader key in this component
                    );

                }

            }, 
            // getapplications: function()
            // {

            //     if(!this.checkNet()) return false;
            //     let currentObj = this;
            //     this.curr_emp_name = '';
            //     this.curr_emp_id = 0;
            //     this.curr_app_id = 0;

            //     this.show_loader_2 = true;
            //     this.application_loading = true;

            //     axios.get(this.$api_url+'/pf/application/list' , {

            //     }).then(function(response){


            //    if(response.data.data.length > 0 )
            //         {
            //       /* Assingning the list */


            //        this.tmp_custom_list = response.data.data.employee_data;

            //         /* Assingning the Options */

            //         this.company_options = Object.keys(response.data.data.options).map((key) => (response.data.data.options[key]));

            //         this.tmp_custom_list = Object.keys(response.data.data.employee_data).map((key) => (response.data.data.employee_data[key]));

            //         /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */

            //         if(this.tmp_custom_list.length > 0 )
            //         {
            //             this.tmp_custom_list.forEach(element => {
            //                     if(element.employee_id > 0)
            //                     {

            //                         this.custom_array[element.id] = element;
            //                         let dop = [];



            //                         /*  If DropDown type one is First Choice */
            //                         /*
            //                             Label is action Label
            //                             and
            //                             Value is the key that will be returned to this component if the action is clicked
            //                         */
            //                         if(element.status == 'Approved')
            //                         {
            //                             dop = dop.concat([]);
            //                         }
            //                         if(element.status == 'Rejected')
            //                         {
            //                             dop = dop.concat([]);
            //                         }

            //                         /* If DropDown type one is Second Choice */
            //                         if(element.status == 'Pending')
            //                         {
            //                             dop = dop.concat([{ label: 'Approve' , value: 1 }]);
            //                             dop = dop.concat([{ label: 'Reject' , value: 3 }]);
            //                         }

            //                         /* Action for all column **/


            //                         element.actions = dop;
            //                     }
            //                 });

            //         }

            //         this.custom_list = this.tmp_custom_list;
            //         this.list_key = this.list_key + 1;
            //         this.show_loader_2 = false;
            //     }
            //     }.bind(this)).catch(function (error){currentObj.serverError(error);});

            // },


        },
        created: function(){
            if(!this.checkNet()) return false;

            this.$validator.reset();
            // this.getapplications();
            this.pfgetEmployees();
            this.pfGetRegisteredEmployees();
        }
    }
</script>
